import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import axios from 'axios';
import LoginForm from '../Shared/LoginForm';
import RegisterForm from '../Shared/RegisterForm';

import {
  passwordsDifferent,
  isIndividualInputValid,
  allInputsValid,
  renderFrontEndError,
} from '../../../helpers/ValidationHelper';

class LoginRegisterPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      loading: false,
      usernameValidationMessage: '',
      usernameValid: false,
      username: '',
      registerEmail: '',
      registerPassword: '',
      passwordConfirmation: '',
      loginEmail: '',
      loginPassword: '',
      error: {},
      validationError: {},
      buttonEnabled: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.validateUsername = this.validateUsername.bind(this);
    this.areInputsValid = this.areInputsValid.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderValidationError = this.renderValidationError.bind(this);
    this.passwordsDifferentMsg = this.passwordsDifferentMsg.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount() {
    const open = !!this.props.showModal;
    if (open) {
      this.setState({ open: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.showModal !== this.props.showModal) {
      this.setState({ open: !!this.props.showModal });
    }
  }

  onChange(e) {
    const t = e.target;
    const obj = {};
    obj[e.target.id] = t.type === 'checkbox' ? t.checked : t.value;

    this.setState(obj, this.individualInputValid.bind(this, e.target));
  }

  usernameValidationPath(name) {
    return `${this.props.usernameValidationPath}?username=${encodeURIComponent(name)}`;
  }

  validateUsername(callback) {
    return (e) => {
      this.setState({ loading: true });

      if (callback) {
        callback(e);
      }

      axios
        .get(this.usernameValidationPath(e.target.value))
        .then(({ data }) => {
          if (data.isUsernameValid) {
            this.setState({
              usernameValidationMessage: 'This username is valid!',
              usernameValid: true,
              loading: false,
            });
          } else {
            this.setState({
              usernameValidationMessage: 'This username is not valid! Please choose another one.',
              usernameValid: false,
              loading: false,
            });
          }
        });
    };
  }

  closeModal(event) {
    event.preventDefault();
    this.setState({ open: !this.state.open, usernameValidationMessage: '' });
    this.props.handleToggle();
  }

  passwordsDifferentMsg() {
    const { registerPassword, passwordConfirmation } = this.state;
    const different = passwordsDifferent(registerPassword, passwordConfirmation);

    return different && <span className="error">Passwords do not match</span>;
  }

  areInputsValid(fieldsToValidate = []) {
    const validationError = allInputsValid(fieldsToValidate, this.state);
    this.setState({ validationError });
    return Object.values(validationError).filter(e => e).length === 0;
  }

  individualInputValid(target) {
    const key = target.id;
    const errors = isIndividualInputValid(target, this.state[key]);
    const formId = target.parentNode.parentNode.parentNode.id;

    if (formId === 'login-form') {
      this.setState({ validationError: errors, loginButtonDisabled: errors[key] });
    } else {
      const doDisable = errors[key] || this.passwordsDifferentMsg();
      this.setState({ validationError: errors, registerButtonDisabled: doDisable });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const nodes = document.querySelectorAll(`#${e.target.id} input[type=text]`);

    if (this.areInputsValid(nodes)) {
      e.target.submit();
    }
  }

  renderCloseButton() {
    return (
      <button className="close" onClick={this.closeModal}>Close</button>
    );
  }

  renderValidationError(msg) {
    return renderFrontEndError(this.state.validationError, msg);
  }

  render() {
    return (
      <div>
        <Modal
          className="modal modal-login"
          overlayClassName="overlay"
          isOpen={this.state.open}
          ariaHideApp={false}
        >
          <div className="modal-login-content">
            <div className="clearfix">
              <div className="col col-12 md-col-6 px2">
                <h4 className="pb1">
                  <i className="fa fa-lock" />
                  &nbsp;Login
                </h4>
                <LoginForm
                  authenticityToken={this.props.authenticityToken}
                  areInputsValid={this.areInputsValid}
                  handleSubmit={this.handleSubmit}
                  renderValidationError={this.renderValidationError}
                  onChange={this.onChange}
                  loginAction={this.props.loginAction}
                  newUserConfimationPath={this.props.newUserConfimationPath}
                  newUserPasswordPath={this.props.newUserPasswordPath}
                  newUserUnlockPath={this.props.newUserUnlockPath}
                  loginButtonDisabled={this.state.loginButtonDisabled}
                  {...this.state}
                />
              </div>
              <div className="col col-12 md-col-6 px2">
                <h4 className="pb1">
                  <i className="fa fa-user" />
                  &nbsp;Register
                </h4>
                <RegisterForm
                  errors={[]}
                  authenticityToken={this.props.authenticityToken}
                  validateUsername={this.validateUsername}
                  usernameValidationMessage={this.state.usernameValidationMessage}
                  usernameValid={this.state.usernameValid}
                  areInputsValid={this.areInputsValid}
                  handleSubmit={this.handleSubmit}
                  renderValidationError={this.renderValidationError}
                  onChange={this.onChange}
                  rergisterAction={this.props.registerAction}
                  usernameValidationPath={this.props.usernameValidationPath}
                  passwordsDifferentMsg={this.passwordsDifferentMsg}
                  registerButtonDisabled={this.state.registerButtonDisabled}
                  {...this.state}
                />
              </div>
            </div>
            {this.renderCloseButton()}
          </div>
        </Modal>
      </div>
    );
  }
}

LoginRegisterPopup.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  loginAction: PropTypes.string.isRequired,
  registerAction: PropTypes.string.isRequired,
  newUserConfimationPath: PropTypes.string.isRequired,
  usernameValidationPath: PropTypes.string.isRequired,
  newUserPasswordPath: PropTypes.string.isRequired,
  newUserUnlockPath: PropTypes.string.isRequired,
  handleToggle: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired
};

export default LoginRegisterPopup;
